import React, { useState } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

export default function AnnouncementBar() {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div className="relative bg-indigo-600 text-white text-sm py-2 px-4 text-center">
      <span className="font-medium">🎉 New: Intent Signals — Spot companies ready to buy before your competitors do.</span>
      <a href="#" className="ml-2 underline font-semibold hover:text-indigo-200 transition-colors">
        Learn more →
      </a>
      <button
        onClick={() => setVisible(false)}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-white/70 hover:text-white transition-colors"
        aria-label="Dismiss"
      >
        <XMarkIcon className="w-4 h-4" />
      </button>
    </div>
  );
}
